module.exports = __webpack_public_path__ + "assets/a05db53dde8389ef8114478870258ddf.png";